<template>
  <div class="dialog">
    <div class="content">
      <img class="loading-icon" :class="type" :src="icon" alt="" />
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading-com",
  props: ["type"],
  computed: {
    text() {
      return this.type === "loading" ? "Processing…" : "Loading failed!";
    },
    icon() {
      let iconName = this.type === "loading" ? "loading" : "icon";
      return require("@/assets/icons/" + iconName + "@3x.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .content {
    height: 170px;
    width: 225px;
    background: url(~@/assets/icons/toast@3x.png);
    box-shadow: 0 50px 30px 0 rgba(0, 0, 0, 0.5);
    background-size: 100% 100%;
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .loading-icon {
      width: 72px;
      &.loading {
        animation: loading 0.8s infinite;
      }
    }
    p {
      margin-top: 16px;
    }
  }
  @keyframes loading {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
